import React from "react";
import WalletToTransferService from "./WalletToTransferService";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";

const WalletToTransfer = () => {
  const {
    handleInputChange,
    handleSubmit,
    formData,
    userAuthData,
    authError,
    isValidUser,
    formErrors,
  } = WalletToTransferService();
  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content cus-entry-form-wrapper">
            <div className="bank-accounts-container account-container false">
              <div className="desktop-header">Wallet to Wallet Transfer</div>

              <div className="bank-entry-section">
                <div className="bank-account-form-wrapper">
                  <form className="bank-entry-form">
                    <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                      <div className="sc-bf9dbd6b-1 dvWaXF input-container ">
                        <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                          Customer No.
                        </p>
                        <input
                          type="text"
                          className="sc-bf9dbd6b-4 "
                          name="mobile"
                          maxLength="10"
                          value={formData.mobile}
                          onChange={handleInputChange}
                        />

                        {isValidUser && userAuthData ? (
                          <span style={{ fontSize: "13px", color: "green" }}>
                            ✅ {userAuthData.outletName} (ID:{" "}
                            {userAuthData.userID})
                          </span>
                        ) : authError ? (
                          <span style={{ fontSize: "13px", color: "red" }}>
                            {authError}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                      <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                        <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                          Amount
                        </p>
                        <input
                          type="text"
                          className="sc-bf9dbd6b-4 "
                          name="amount"
                          value={formData.amount}
                          onChange={handleInputChange}
                        />
                        {formErrors.amount && (
                          <span style={{ fontSize: "13px", color: "red" }}>
                            {formErrors.amount}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                      <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                        <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                          Remark
                        </p>
                        <textarea
                          className="sc-bf9dbd6b-4 "
                          name="remark"
                          value={formData.remark}
                          onChange={handleInputChange}
                        />
                        {formErrors.remark && (
                          <span style={{ fontSize: "13px", color: "red" }}>
                            {formErrors.remark}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="submit-bank-details-btn-container">
                      <button
                        type="btn"
                        onClick={handleSubmit}
                        className="sc-wattetButton"
                        disabled={!isValidUser}
                      >
                        SUBMIT
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WalletToTransfer;
